import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-12-24
	search(params) {
		return axios.get('/mes/manufactures?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-24
	batchFinish(params) {
		return axios.put('/mes/manufactures/batch-finish', params)
	},
	// 2020-12-24
	batchInspect(params) {
		return axios.put('/mes/manufactures/batch-inspect', params)
	},
	// 2020-12-24
	batchUpdatePhaseHour(params) {
		return axios.put('/mes/manufactures/batch-update-phase-hour', params)
	},
	// 2021-08-07
	updatePhaseHour(id, params) {
		return axios.put('/mes/manufactures/' + id + '/update-phase-hour', params)
	},
	// 2020-12-24
	exportExcel(params) {
		return axios.get('/mes/manufactures/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-24
	updateRemark(id, params) {
		return axios.put('/mes/manufactures/' + id + '/update-remark', params)
	},
	// 2021-01-21
	updatePhasePrice(id, params) {
		return axios.put('/mes/manufactures/' + id + '/update-phase-price', params)
	},
	// 2020-12-24
	delete(id) {
		return axios.delete('/mes/manufactures/' + id)
	},
	// 2020-12-28
	findBySalaryId(id) {
		return axios.get('/mes/manufactures/find-by-salary-id/' + id)
	},
	// 2021-03-01
	findBySalaryIdSearch(id, params) {
		return axios.get('/mes/manufactures/find-by-salary-id/' + id + '/search', params)
	},
	// 2021-11-12
	findBySalaryIdGroupCount(salaryId) {
		return axios.get('/mes/manufactures/find-by-salary-id-group-count/' + salaryId);
	},
	// 2021-11-12
	findBySalaryIdGroupCountSearch(salaryId, params) {
		return axios.get('/mes/manufactures/find-by-salary-id-group-count/' + salaryId + '/search', params);
	},
	// 2020-12-28
	exportExcelBySalaryId(id) {
		return axios.get('/mes/manufactures/export-excel-by-salary-id/' + id)
	},

	// 2020-12-28
	clearSettle(id) {
		return axios.put('/mes/manufactures/' + id + '/clear-settle',)
	},
	// 2020-12-28
	updateAmountAndSettleRemark(id, params) {
		return axios.put('/mes/manufactures/' + id + '/update-amount-and-settle-remark', params)
	},
	// 2020-12-28
	batchUpdateAmountAndSettleRemark(params) {
		return axios.put('/mes/manufactures/batch-update-amount-and-settle-remark', params)
	},

	// update(id, params) {
	// 	return axios.put('/mes/manufactures/' + id, params)
	// },
	// 2021-07-08
	unFinished(params) {
		return axios.get('/mes/manufactures/un-finished', params);
	},

	// 2020-12-25
	findById(id) {
		return axios.get('/mes/manufactures/' + id);
	},
	// tracking(params) {
	// 	return axios.get('/mes/manufactures/tracking?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	// }
}

